import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./styles.css";

export const CustomTabPanel = styled(TabPanel)(({ theme }) => ({
  borderTop: `0`,
  borderBottomRightRadius: "15px",
  borderBottomLeftRadius: "15px",
  fontFamily: "Lato",
  "@media (max-width: 900px)": {
    padding: "12px"
  }
}));

const TabComponent = ({ panels, variant }) => {
  const [value, setValue] = useState(panels[0].id);

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const CustomTabList = styled(TabList)(({ theme }) => ({
    backgroundColor: "#ffff",
    border: `1px solid ${theme.palette.divider}`,
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "6px"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#6A6AD8",
      borderRadius: "10px"
    }
  }));

  const TabContextStyled = styled(TabContext)(({ theme }) => ({
    "& .MuiTab-root": {
      color: theme.palette.common.white,
      borderTop: `1px solid ${theme.palette.divider}`
    }
  }));

  const CustomTab = styled(Tab)(() => ({
    padding: "35px 25px",
    textTransform: "initial",
    fontSize: "16px,",
    fontWeight: "900",
    fontFamily: "Lato",
    color: "#6A6AD8",
    "&.Mui-selected": {
      color: "#FFFFFF",
      backgroundColor: "#6A6AD8"
    },
    "@media (max-width: 590px)": {
      padding: "20px 10px",
      fontSize: "12px"
    }
  }));

  const CustomTabPanel = styled(TabPanel)(({ theme }) => ({
    padding: "40px",
    border: `1px solid ${theme.palette.divider}`,
    borderTop: `0`,
    borderBottomRightRadius: "15px",
    borderBottomLeftRadius: "15px",
    fontFamily: "Lato",
    "@media (max-width: 900px)": {
      padding: "10px 10px"
    }
  }));

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContextStyled
        orientation="vertical"
        variant="scrollable"
        value={value}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <CustomTabList
            variant={
              variant ? variant : isSmallScreen ? "scrollable" : "fullWidth"
            }
            scrollButtons="auto"
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            {panels.map((item) => (
              <CustomTab label={item.name} value={item.id} key={item.id} />
            ))}
          </CustomTabList>
        </Box>
        {panels.map((item) => (
          <CustomTabPanel value={item.id} key={item.id}>
            {item.content}
          </CustomTabPanel>
        ))}
      </TabContextStyled>
    </Box>
  );
};

export default TabComponent;
